import { speedMeter } from '../../../components/shared/vector-images';
import { toggleLayerIfRequired } from '../_helpers';

const layer = {
  displayName: 'Speed zones',
  synonyms: '',
  group: 'mapboxLayer',
  typeUrl: 'speed-zone',
  icon: {
    baseShape: speedMeter,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 100,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
};

layer.onInitialize = (/* map */) => {
  /* noop */
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'speed-limitation-area line', show);
  toggleLayerIfRequired(map, 'speed-limitation-area fill', show);
  toggleLayerIfRequired(map, 'speed-limitation-area symbol', show);
};

export default layer;
